import { RightSidebarService } from './suggestions.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { loadSuggested, loadSuggestedSuccess } from './suggestions.actions';
import { switchMap, map, catchError } from 'rxjs/operators';

@Injectable()
export class SuggestionsEffects {
  constructor(
    private actions$: Actions,
    private service: RightSidebarService
  ) {}

  @Effect()
  loadSuggested$ = this.actions$.pipe(
    // TODO: refactor
    ofType(loadSuggested),
    switchMap(() => {
      return this.service.getSuggested().pipe(
        map((arrays) => {
          const arr = arrays.suggested.map((item) => item.users);

          return [].concat.apply([], arr);
        }),
        map((items: any) => loadSuggestedSuccess({ items })),
        catchError((error) => error)
      );
    })
  );
}
